import React, { Component, Fragment } from 'react'
import qs from 'qs'
import cookies from 'next-cookies'

import { fetchPageData, logError } from '../../utils'

import { staticRoutes } from '../../frontend/staticroutes/index'
import getSharedLayout from '../shared-layout'

export default class Static extends Component {
  static async getInitialProps(ctx) {
    const { query, res } = ctx
    const { routeName, seoUrl, ...params } = qs.parse(query)
    const allCookies = cookies(ctx)

    try {
      const [pageData] = await Promise.all([
        fetchPageData({ ctx: { query: { seoUrl: '/' } } }),
      ])

      // Setting custom header for makaira static pages
      if (res) {
        res.set('X-makaira-action', 'static')
      }

      return {
        pageData,
        params,
        seoUrl,
        allCookies,
      }
    } catch (error) {
      logError(error, 'nextjs:static')

      if (res) {
        res.statusCode = 500
      }

      /**
       * Returning an empty here is intentional, see:
       * https://github.com/zeit/next.js/blob/master/errors/empty-object-getInitialProps.md
       */
      return {}
    }
  }

  normalizePath = (path) => {
    return path?.replace(/\/$/, '')
  }

  render() {
    const normalizedSeoUrl = this.normalizePath(this.props.seoUrl)
    const route = staticRoutes.find((k) => k.url === normalizedSeoUrl)
    const MainComponent = route?.component || Fragment

    return <MainComponent />
  }
}

Static.getLayout = getSharedLayout
